import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMipsSubmissionBlock from '@store/reducers/mips-submission-block/mips-submission-block.reducer';

export const selectMipsSubmissionBlockState = createFeatureSelector<fromMipsSubmissionBlock.State>(
  fromMipsSubmissionBlock.mipsSubmissionBlockFeatureKey
);

export const selectOrganizationSubmissionStatuses = createSelector(
  selectMipsSubmissionBlockState,
  (state) => state.statuses
);

export const selectMipsSubmissionBlockLoading = createSelector(
  selectMipsSubmissionBlockState,
  (state) => state.isLoading
);

export const selectMipsSubmissionBlockSaving = createSelector(
  selectMipsSubmissionBlockState,
  (state) => state.isSaving
);

export const selectOrganizationSubmissionStatusById = (organizationId: number) =>
  createSelector(
    selectOrganizationSubmissionStatuses,
    (statuses) => statuses.find((status) => status.organizationId === organizationId) ?? null
  );

export const selectIsOrganizationSubmissionBlocked = (organizationId: number) =>
  createSelector(
    selectOrganizationSubmissionStatusById(organizationId),
    (status) => status?.isBlocked ?? false
  );

export const selectOrganizationBlockReasonCodes = (organizationId: number) =>
  createSelector(
    selectOrganizationSubmissionStatusById(organizationId),
    (status) => status?.reasonCodes ?? []
  );
